import React from 'react';
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../ControllerContext';
import {EstimatedTax} from './EstimatedTax/EstimatedTax';
import {OrderSummaryDataHook} from '../OrderSummary';
import s from '../OrderSummary.scss';
import {TotalShipping} from './TotalShipping/TotalShipping';
import {DeliveryMethod} from './DeliveryMethod/DeliveryMethod';
import {DeliveryError} from './DeliveryError/DeliveryError';
import {DeliveryNotification} from './DeliveryNotification/DeliveryNotification';
import {AdditionalFees} from './AdditionalFees/AdditionalFees';
import {SPECS} from '../../../../../../domain/specs';

const FormattedSubTotal = () => {
  const {t} = useTranslation();
  const {formattedItemsTotal} = useControllerProps().cartStore.cart.convertedTotals;

  return (
    <dl>
      <dt>{t('cart.subtotal')}</dt>
      <dd
        data-hook={OrderSummaryDataHook.SubTotalsValue}
        data-wix-sub-totals-value={OrderSummaryDataHook.SubTotalsValue}>
        {formattedItemsTotal}
      </dd>
    </dl>
  );
};

export const SubTotals = () => {
  const {
    shouldDisplayDelivery,
    shouldDisplayDeliveryMethodSelection,
    shouldDisplayTax,
    shouldDisplayDeliveryError,
    isFullAddressRequired,
    shouldDisplayAdditionalFees,
  } = useControllerProps().orderStore;
  const {experiments} = useExperiments();
  const ShouldChangeMaxViewportMobile = experiments.enabled(SPECS.ChangeMaxViewportMobile);

  return (
    <div
      data-hook={OrderSummaryDataHook.SubTotalsRoot}
      className={/* istanbul ignore next */ ShouldChangeMaxViewportMobile ? s.divider : s.dividerViewport}>
      <FormattedSubTotal />

      {shouldDisplayAdditionalFees && <AdditionalFees />}

      {shouldDisplayDelivery && <TotalShipping />}

      {shouldDisplayDeliveryMethodSelection && <DeliveryMethod />}

      {shouldDisplayTax && <EstimatedTax />}

      {shouldDisplayDeliveryError && (isFullAddressRequired ? <DeliveryNotification /> : <DeliveryError />)}
    </div>
  );
};
